require('./mortgageRequestTargetDate.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const moment = require('moment');
const { withRouter } = require('react-router-dom');

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKModal = require('components/commons/OKModal/OKModal');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const language = getLanguage();

// @ components
const ChooseDate = require('./chooseDate');
const DaysLeft = require('./daysLeft');

//@actions
const targetDateActions = require('actions/mortgageRequest/mortgageRequestTargetDate');
const addEmailActions = require('actions/mortgageRequest/mortgageRequestAddEmail');

//@constants
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

//@ utilities
const {
    recordLink,
    EVENT_INTERACTION_MORTGAGE_REQUEST,
    EVENT_ACTION_SELECT_DATE,
    EVENT_ACTION_SELECT_ANOTHER_DATE,
} = require('utilities/tagging');

class MortgageRequestTargetDate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTargetDateCalendar: false
        };

        this.handleToggleCalendar = this.handleToggleCalendar.bind(this);
        this.onHandleChangeDate = this.onHandleChangeDate.bind(this);
        this.handleGoToPanel = this.handleGoToPanel.bind(this);

        this.minDate = moment().startOf('day').add('3', 'weeks');
        this.maxDate = moment().startOf('day').add('5', 'years');
        this.selectedDate = moment().startOf('day');
    }

    onHandleChangeDate(date) {
        const { setTargetDate } = this.props;

        if (date) {
            const d = new Date(date);
            this.setState({
                showTargetDateCalendar: false,
            });

            setTargetDate(d);
            this.daysLeft = this.calculateDaysLeft(date);
        }
    }

    calculateDaysLeft(date) {
        const diff_ms = new Date(date) - new Date();
        return (diff_ms > 0) ? Math.floor(diff_ms / 86400000) : 0; //to days
    }

    handleGoToPanel(evt) {
        (evt) && evt.preventDefault();

        const { saveAddEmail, mortgageRequestAddMail, isClientWithoutAccounts, history } = this.props;

        if (!isClientWithoutAccounts) {
            if (mortgageRequestAddMail.get('emailValid')) {
                saveAddEmail(history);
            }
        }
        else {
            saveAddEmail(history);
        }

    }

    handleToggleCalendar(evt, dateSelected) {
        if (evt) {
            evt.preventDefault();

            const eventName = dateSelected ? EVENT_ACTION_SELECT_ANOTHER_DATE : EVENT_ACTION_SELECT_DATE;
            recordLink(EVENT_INTERACTION_MORTGAGE_REQUEST, eventName);
        }

        this.setState({
            showTargetDateCalendar: !this.state.showTargetDateCalendar
        })
    }

    render() {
        const { mortgageRequestState, mortgageRequestAddMail, mortgageRequestTargetDate, isClientWithoutAccounts } = this.props;
        const contentBoxTitleClientNoClient = (!isClientWithoutAccounts) ? formatText('mortgageRequestManager-welcomeOpenBankMortgageClient') : formatText('mortgageRequestManagerInfo-welcomeOpenBankMortgage')

        if (mortgageRequestState.get('fechaObjetivo')) {
            const date = mortgageRequestState.get('fechaObjetivo');
            this.selectedDate = moment(date).startOf('day');
            this.daysLeft = this.calculateDaysLeft(date);
        }
        const isLoadingContinue = mortgageRequestAddMail.get('isFetching');
        const isLoadingTargetDate = mortgageRequestTargetDate.get('isFetching');
        const disclaimer = !isClientWithoutAccounts && (
            <div className="row">
                <div className="col-sm-12">
                    <div className="mortgage-request-target-date__warning">
                        <OKMessage>
                            <FormattedText value="mortgageRequestManager-noteNew" />
                        </OKMessage>
                    </div>
                </div>
            </div>
        );
        const content = (
            <DatePickerCustom
                id="targetDate"
                minDate={this.minDate}
                maxDate={this.maxDate}
                selectedDate={this.selectedDate}
                callback={this.onHandleChangeDate}
                language={language}
                placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
            />
        );

        return (
            <ContentBox
                title={contentBoxTitleClientNoClient}
                titleSeparator
                smallTitle
                customClassName="mortgage-request-target-date__custom-title-appareance">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="mortgage-request-target-date__choose-date">
                            {
                                !mortgageRequestState.get('fechaObjetivo')
                                    ? formatText('mortgageRequestManager-objectiveDateTitle')
                                    : formatText('mortgageRequestManager-objectiveRequestTitle')
                            }
                        </div>
                    </div>
                </div>
                {
                    !mortgageRequestState.get('fechaObjetivo') ?
                        <ChooseDate
                            onHandleGoToPanel={this.handleGoToPanel}
                            onHandleToggleCalendar={this.handleToggleCalendar}
                            isLoadingTargetDate={isLoadingTargetDate}
                            isLoadingContinue={isLoadingContinue}
                            disabled={!mortgageRequestState.get('idExpediente')}
                        />
                        :
                        <DaysLeft
                            daysLeft={this.daysLeft}
                            onHandleGoToPanel={this.handleGoToPanel}
                            onHandleToggleCalendar={this.handleToggleCalendar}
                            isLoadingTargetDate={isLoadingTargetDate}
                            isLoadingContinue={isLoadingContinue}
                            disabled={!mortgageRequestState.get('idExpediente')}
                        />
                }
                <OKModal
                    content={content}
                    isOpen={this.state.showTargetDateCalendar}
                    onCloseCallback={this.handleToggleCalendar}
                />
                {disclaimer}
            </ContentBox>
        );
    }
}

MortgageRequestTargetDate.propTypes = {
    mortgageRequestState: PropTypes.object,
    mortgageRequestAddMail: PropTypes.object,
    mortgageRequestTargetDate: PropTypes.object,
    setTargetDate: PropTypes.func,
    saveAddEmail: PropTypes.func,
    isClientWithoutAccounts: PropTypes.bool,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = MortgageRequestTargetDate;
module.exports.MortgageRequestTargetDate = withRouter(connect(state => ({
    mortgageRequestAddMail: state.mortgageRequestAddEmail,
    mortgageRequestState: state.mortgageRequestState,
    mortgageRequestTargetDate: state.mortgageRequestTargetDate
}), {
    setTargetDate: targetDateActions.setTargetDate,
    saveAddEmail: addEmailActions.saveAddEmail,
})(MortgageRequestTargetDate));
